var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"canvas-wrap",style:({height: _vm.height + 'px'}),on:{"click":_vm.refresh}},[_c('canvas',{attrs:{"id":"s-canvas","width":_vm.width,"height":_vm.height}})])}
var staticRenderFns = []

export { render, staticRenderFns }